import { jwtDecode } from "jwt-decode";

const DELEGATED_ACCESS_TOKEN_KEY = "fluxi_delegated_access_token";

const browserStorage = () =>
  typeof window === "undefined"
    ? null
    : {
        local: window.localStorage,
        session: window.sessionStorage,
      };

export function getAccessToken(): string | null {
  const storage = browserStorage();
  return (
    storage?.session.getItem(DELEGATED_ACCESS_TOKEN_KEY) ||
    storage?.local.getItem("access_token") ||
    null
  );
}

export function getDelegatedAccessToken(): string | null {
  return browserStorage()?.session.getItem(DELEGATED_ACCESS_TOKEN_KEY) || null;
}

export function storeDelegatedAccessToken(token: string) {
  browserStorage()?.session.setItem(DELEGATED_ACCESS_TOKEN_KEY, token);
}

export function migrateLegacyDelegatedAccessToken(): boolean {
  const storage = browserStorage();
  if (!storage || storage.session.getItem(DELEGATED_ACCESS_TOKEN_KEY)) return false;

  const legacyToken = storage.local.getItem("access_token");
  if (!legacyToken) return false;

  try {
    const claims = jwtDecode<{ support_session_id?: string }>(legacyToken);
    if (!claims.support_session_id) return false;
  } catch {
    return false;
  }

  storage.session.setItem(DELEGATED_ACCESS_TOKEN_KEY, legacyToken);
  storage.local.removeItem("access_token");
  return true;
}

export function clearDelegatedAccessToken() {
  browserStorage()?.session.removeItem(DELEGATED_ACCESS_TOKEN_KEY);
}

export function clearActiveAccessToken() {
  const storage = browserStorage();
  if (!storage) return;

  if (storage.session.getItem(DELEGATED_ACCESS_TOKEN_KEY)) {
    storage.session.removeItem(DELEGATED_ACCESS_TOKEN_KEY);
    return;
  }

  storage.local.removeItem("access_token");
  storage.local.removeItem("refresh_token");
}
